import { sendChangeServicesEvent } from './sendChangeServicesEvent';
import { sendPublicationUnavailableEvent } from './sendPublicationUnavailableEvent';
import { sendCheckServiceStatusChangeEvent } from './sendCheckServiceStatusChangeEvent';

export const MicrofrontendEvent = {
  sendChangeServicesEvent,
  sendPublicationUnavailableEvent,
  sendCheckServiceStatusChangeEvent,
};
